module.exports = __webpack_public_path__ + "assets/img/ic-export-p.fb1dd81d.svg";